import { useEffect, useState } from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { Layout } from "./components/Layout";
import { getAccessToken, startLogin } from "./lib/auth";
import { AgentsList } from "./pages/AgentsList";
import { Approvals } from "./pages/Approvals";
import { AuthCallback } from "./pages/AuthCallback";
import { DealDetail } from "./pages/DealDetail";
import { Deals } from "./pages/Deals";
import { Directory } from "./pages/Directory";
import { DisputeDetail } from "./pages/DisputeDetail";
import { DisputeNew } from "./pages/DisputeNew";
import { Disputes } from "./pages/Disputes";
import { Negotiations } from "./pages/Negotiations";
import { OfferDetail } from "./pages/OfferDetail";
import { OfferEdit } from "./pages/OfferEdit";
import { OfferNew } from "./pages/OfferNew";
import { Offers } from "./pages/Offers";
import { Reputation } from "./pages/Reputation";
import { Settings } from "./pages/Settings";
import { Traffic } from "./pages/Traffic";
import { TrafficDetail } from "./pages/TrafficDetail";
import { TrafficEdit } from "./pages/TrafficEdit";
import { TrafficNew } from "./pages/TrafficNew";
import { Welcome } from "./pages/Welcome";

function Billing() {
	return <div className="p-6">Billing — Stripe excluded by user, deferred</div>;
}

export function App() {
	const loc = useLocation();
	const [authed, setAuthed] = useState<boolean>(() => !!getAccessToken());

	useEffect(() => {
		if (loc.pathname === "/auth/callback") return;
		if (!getAccessToken()) {
			startLogin(loc.pathname);
		} else {
			setAuthed(true);
		}
	}, [loc.pathname]);

	if (loc.pathname === "/auth/callback") {
		return <AuthCallback />;
	}
	if (!authed) {
		return <div className="p-6 text-sm text-neutral-600">Redirecting to sign in…</div>;
	}

	return (
		<Layout>
			<Routes>
				<Route path="/" element={<Welcome />} />
				<Route path="/offers" element={<Offers />} />
				<Route path="/offers/new" element={<OfferNew />} />
				<Route path="/offers/:id" element={<OfferDetail />} />
				<Route path="/offers/:id/edit" element={<OfferEdit />} />
				<Route path="/traffic" element={<Traffic />} />
				<Route path="/traffic/new" element={<TrafficNew />} />
				<Route path="/traffic/:id" element={<TrafficDetail />} />
				<Route path="/traffic/:id/edit" element={<TrafficEdit />} />
				<Route path="/deals" element={<Deals />} />
				<Route path="/deals/:id" element={<DealDetail />} />
				<Route path="/negotiations" element={<Negotiations />} />
				<Route path="/approvals" element={<Approvals />} />
				<Route path="/agents" element={<AgentsList />} />
				<Route path="/directory" element={<Directory />} />
				<Route path="/disputes" element={<Disputes />} />
				<Route path="/disputes/new" element={<DisputeNew />} />
				<Route path="/disputes/:id" element={<DisputeDetail />} />
				<Route path="/reputation" element={<Reputation />} />
				<Route path="/billing" element={<Billing />} />
				<Route path="/settings" element={<Settings />} />
			</Routes>
		</Layout>
	);
}
